import { FC, useEffect } from 'react';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import {
  MESSAGE_TYPE_CREATE_DEALS,
  MESSAGE_TYPE_DEAL_STATUS_CHANGE,
} from 'srcJs/components/realtime-notification/constants/constants';

type PropTypes = {
  callback: () => void;
};

const BalanceObserver: FC<PropTypes> = ({
  callback,
}) => {
  useEffect(() => {
    realtimeNotification.addListener(MESSAGE_TYPE_CREATE_DEALS, callback);
    realtimeNotification.addListener(MESSAGE_TYPE_DEAL_STATUS_CHANGE, callback);

    return () => {
      realtimeNotification.removeListener(callback);
    };
  }, []);

  return null;
};

export { BalanceObserver };
